import api from './api';

export const authUser = async (email: string, password: string) => {
  localStorage.clear();
  let headers = {
    'Content-Type': 'application/json',
    Authorization: 'Basic ' + btoa(`${email}:${password}`),
  };

  const response = await api.post(`/auth`, {}, { headers: headers });

  if (
    response.status === 200 ||
    response.status === 201 ||
    response.status === 204
  ) {
    const { token, user } = response.data;

    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', `Bearer ${token}`);
  }
  return response;
};

export const checkAuth = (allow: string[]) => {
  const token = localStorage.getItem('token');

  // verifica se existe o token
  if (!Boolean(token)) return false;

  // verifica se existe a role
  const user: any = localStorage.getItem('user');
  if (!Boolean(user)) return false;

  const { role } = JSON.parse(user);

  // verifica se tem permissao
  return allow.includes(role);
};
